var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7843_20683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.091 8.8055C16.6097 8.8055 20.2728 7.58446 20.2728 6.07822C20.2728 4.57199 16.6097 3.35095 12.091 3.35095C7.5723 3.35095 3.90918 4.57199 3.90918 6.07822C3.90918 7.58446 7.5723 8.8055 12.091 8.8055Z",
    stroke: "#44494D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2728 12.4419C20.2728 13.951 16.6365 15.1692 12.091 15.1692C7.54554 15.1692 3.90918 13.951 3.90918 12.4419",
    stroke: "#44494D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90918 6.07825V18.8055C3.90918 20.3146 7.54554 21.5328 12.091 21.5328C16.6365 21.5328 20.2728 20.3146 20.2728 18.8055V6.07825",
    stroke: "#44494D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7843_20683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1818,
    height: 20,
    fill: "white",
    transform: "translate(3 2.44189)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStorage);
export default __webpack_public_path__ + "static/media/IconStorage.afed9aa9.svg";
export { ForwardRef as ReactComponent };